import React from "react";
import { FaCheckSquare } from "react-icons/fa";

const QA = ({ inputText, isGenerating, text, formattedText }) => {
  console.log(inputText, isGenerating, text, formattedText);
  return (
    <>
      <p class="preset-title">Q&A</p>

      {inputText ? (
        <>
          <h6 className='d-flex align-items-center gap-2' style={{color: '#011225'}}> <FaCheckSquare style={{color: '#55C7A8'}} /> This is what you enter.</h6>
          <p class="text-muted">Q: {inputText}</p>
          {isGenerating == true ? (
            <p
              class="text- mb-0 mt-2"
              style={{
                fontSize: "14px",
                color: "#A020F0",
              }}
            >
              Processing...
            </p>
          ) : (
            <>
              { text && <h6 className='d-flex align-items-center gap-2' style={{color: '#011225'}}> <FaCheckSquare style={{color: '#55C7A8'}} /> This is what we generate for you.</h6> }
                <p
                  style={{
                    color: "black",
                  }}
                  class="text- mb-0 text-"
                >
                  {text}
                </p>
              
            </>
          )}
        </>
      ) : (
        <>
         <h6 className='d-flex align-items-center gap-2' style={{color: '#011225'}}> <FaCheckSquare style={{color: '#55C7A8'}} /> This is what you enter.</h6>
          <p class="text-muted" style={{ fontSize:"14px" }}>Q: What is Blockchain?</p>
          
          <h6 className='d-flex align-items-center gap-2' style={{color: '#011225'}}> <FaCheckSquare style={{color: '#55C7A8'}} /> This is what we generate for you.</h6>
          <p
     style={{ color: "black",fontSize:"14px" }}
          >
            A: Blockchain is a decentralized, distributed, and public digital
            ledger that is used to record transactions across many computers so
            that any involved record cannot be altered retroactively, without
            the alteration of all subsequent blocks.
          </p>
        </>
      )}
    </>
  );
};

export default QA;
